import { IImageProps, IImageGlobalCSProps } from '@/lib/contentstack-sdk/types';

// Legacy image typeguard
export function isIImageProps(obj: any): obj is IImageProps {
  return (
    typeof obj.desktop_image_url === 'string' &&
    typeof obj.mobile_image_url === 'string' &&
    typeof obj.tablet_image_url === 'string' &&
    'alt' in obj &&
    'entry_title' in obj
  );
}

// Type guard for IImageGlobalCSProps
export function isIImageGlobalCSProps(obj: any): obj is IImageGlobalCSProps {
  return (
    (typeof obj.mobile_image_url === 'object' ||
      obj.mobile_image_url === null) &&
    'decorative' in obj &&
    'mobile_aspect_ratio' in obj &&
    'quality' in obj &&
    'priority' in obj &&
    'mobile_position' in obj
  );
}
